// extracted by mini-css-extract-plugin
export default {"fade":"ModalFade_fade__JQw87","modalFadeIn":"ModalFade_modalFadeIn__KCSjc","closing":"ModalFade_closing__ZOpgF","modalFadeOut":"ModalFade_modalFadeOut__WLXZH"};